import { render, staticRenderFns } from "./TreeChildren.vue?vue&type=template&id=21410819&scoped=true&"
import script from "./TreeChildren.vue?vue&type=script&lang=js&"
export * from "./TreeChildren.vue?vue&type=script&lang=js&"
import style0 from "./TreeChildren.vue?vue&type=style&index=0&id=21410819&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21410819",
  null
  
)

export default component.exports